function cov_1pa8whsf3a() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/FavoriteFilled.tsx";
  var hash = "f26dbe0089c12788f7eb9ee050e92a3da1745f1a";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/FavoriteFilled.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 55
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "f26dbe0089c12788f7eb9ee050e92a3da1745f1a"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1pa8whsf3a = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_1pa8whsf3a();
var Icon = (cov_1pa8whsf3a().s[0]++, {
  name: 'favorite-filled',
  svg: "<path d=\"M2.57693 7.40113C4.06598 3.09942 9.73548 2.68892 12.0001 6.21636C14.2647 2.68892 19.9342 3.09941 21.4233 7.40113C22.038 9.17717 21.6641 11.1461 20.441 12.573L13.3288 20.8706C12.6304 21.6854 11.3698 21.6854 10.6714 20.8706L3.55921 12.573C2.33609 11.1461 1.96214 9.17717 2.57693 7.40113Z\" fill=\"currentColor\"/>"
});
export default Icon;